<template>
    <div>
        <ams-base-chart chartTitle="Outcome Type" :chartType="ChartTypes.BAR" :data="chartData" :showLegend="false" :customizeInnerColor="true" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

import { ChartTypes } from '../../../../../../enums';
import { colorBasedOnOutcome } from '../../../../../../utilities/colors';

const props = defineProps({
    jsonData: {
        type: Array,
    },
});

const chartData = ref([]);

onMounted(() => {
    loadChartData();
});

const loadChartData = () => {
    chartData.value = props.jsonData
        ?.filter((item) => item.name != 'None')
        ?.map((data) => {
            return {
                label: data.name,
                values: [
                    {
                        value: data.tot,
                        bgcolor: colorBasedOnOutcome(data.name),
                    },
                ],
            };
        });
};
</script>
